export const getDefaultValue = (question) => {
  if (question.type === 'slider') return null
  if (question.type === 'face') return ''
  if (question.type === 'star') return 0
  if (question.type === 'radio') return ''
  if (question.type === 'multiple_choice') return []
  if (question.type === 'text') return ''
  return null
}